import {AppRegistry, Platform} from 'react-native';
import {enableScreens} from 'react-native-screens';
import App from '../src/App';
import {name as appName} from '../app.json';
import {registerServiceWorker} from './pwa/registerSW';

// Native screens freeze/detach views and commonly break TextInput focus on web/PWA.
if (Platform.OS === 'web') {
  enableScreens(false);
}

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});

registerServiceWorker();
